import { Box, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import { SectionEyebrow } from '@scoutingops/ui';

const faqs = [
  {
    q: 'Do I need any technical skills?',
    a: 'None. If you can type an email, you can build your site with Scouting Ops Site. There\u2019s no code, no CSS, no hosting to manage. Everything is point-and-click.',
  },
  {
    q: 'Which programs do you support?',
    a: 'We are not affiliated with any specific organization, but we have units from across the spectrum from Scouting America to Girl Scouts, Camp Fire, 4-H and more. Pick your unit type and we pre-fill content tailored to your program.',
  },
  {
    q: 'Is this really free?',
    a: 'Yes \u2014 you can create and publish a full unit site on a free Scouting Ops Site URL at no cost. Custom domains (like pack123.org) are available on paid plans.',
  },
  {
    q: 'What happens when leadership changes?',
    a: 'Invite other leaders as editors with role-based permissions. When leadership transitions, the site stays. No single point of failure.',
  },
  {
    q: 'Is it safe for youth?',
    a: 'Scouting Ops Site has no fields for youth personal information. Contact forms go through the site \u2014 no email addresses are exposed. Templates are built around youth program communication guidelines.',
  },
  {
    q: 'Can I use my own domain?',
    a: 'Absolutely. Connect pack123.org, troop456.com, or any domain you own. We walk you through the DNS setup step by step.',
  },
  {
    q: 'How is this different from Wix or Squarespace?',
    a: 'Those are general-purpose tools that start with a blank page. Scouting Ops Site starts with program-specific pages, content, and structure already in place. You just customize \u2014 not create from scratch.',
  },
];

export default function FaqSection() {
  return (
    <Box component="section" sx={{ py: { xs: 10, md: 14 }, bgcolor: 'action.hover' }}>
      <Container maxWidth="lg">
        <Stack spacing={1.5} sx={{ alignItems: "center", textAlign: "center", mb: 7 }}>
          <SectionEyebrow>Questions &amp; Answers</SectionEyebrow>
          <Typography variant="h3" sx={{ fontWeight: 800 }}>Frequently Asked Questions</Typography>
        </Stack>

        <Stack spacing={1.5} sx={{ maxWidth: 900, mx: 'auto' }}>
          {faqs.map((faq) => (
            <Card key={faq.q} variant="outlined">
              <CardContent sx={{ p: 2.5 }}>
                <Typography sx={{ fontWeight: 700, mb: 0.75 }}>{faq.q}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>{faq.a}</Typography>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
